import { Controller } from "@hotwired/stimulus"

/**
 * Admin Search Form Controller - Server-side search with debounce
 *
 * Features:
 * - Debounced form submission (300ms)
 * - Auto-submit on input
 * - Preserves form method (GET)
 *
 * Usage:
 * <%= form_with data: { controller: "admin-search-form" } do |f| %>
 *   <%= f.text_field :q, data: { action: "input->admin-search-form#search" } %>
 * <% end %>
 */
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  // Immediate submit for selects (a CSP nonce blocks inline onchange handlers)
  submit() {
    this.element.requestSubmit()
  }

  search() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    this.debounceTimer = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }
}
